import { useNavigate } from "react-router-dom";
import { useState, useCallback, useMemo, useEffect } from "react";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import '../css/Clientes.css';
import '../css/rotating-icon.css';
import { ReactComponent as Eliminar } from '../assets/icon/eliminar.svg';
import { ReactComponent as Editar } from '../assets/icon/editar.svg';
import { ReactComponent as Recargar } from '../assets/icon/recargar.svg';
import { ReactComponent as ExcelIcon } from '../assets/icon/excel.svg';
import TablaClientes from "../Clientes/TablaClientes";
import { useClientes, deleteCliente, getClientesConTarjetas } from '../services/clientes';
import { useToast } from '../contexts/ToastContext';
import BulkDeleteModal from '../Components/BulkDeleteModal';

function Clientes() {
  const navigate = useNavigate();
  const [selectedIds, setSelectedIds] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletingItems, setDeletingItems] = useState([]);
  const [exporting, setExporting] = useState(false);
  const { showError, showSuccess } = useToast();

  const { data: clientes, loading, error, refetch } = useClientes({
    immediate: true
  });

  useEffect(() => {
    if (error) {
      showError(error, 'Error de conexión');
    }
  }, [error, showError]);

  const handleDeleteSelected = useCallback(async () => {
    if (selectedIds.length === 0) return;
    
    const itemsToDelete = clientes.filter(c => selectedIds.includes(c.IdCliente));
    setDeletingItems(itemsToDelete);
    setShowDeleteModal(true);
  }, [selectedIds, clientes]);

  const handleConfirmDelete = useCallback(async (id, item) => {
    const phone = item.Phone;
    const result = await deleteCliente(phone);
    if (result.success && (result.error === 0 || result.error === undefined)) {
      return { success: true };
    }
    throw new Error(result.mensaje || 'Error al eliminar');
  }, []);

  const handleDeleteComplete = useCallback(() => {
    setShowDeleteModal(false);
    setSelectedIds([]);
    refetch();
    showSuccess('Cliente(s) eliminado(s) correctamente');
  }, [refetch, showSuccess]);

  const handleEditSelected = useCallback(() => {
    if (selectedIds.length === 1) {
      navigate(`/dashboard/clientes/editarcliente/${selectedIds[0]}`);
    }
  }, [selectedIds, navigate]);

  const handlePageChange = useCallback((newPage) => {
    setCurrentPage(newPage);
  }, []);

  const buttonStates = useMemo(() => {
    const hasNoSelection = selectedIds.length === 0;
    const hasSingleSelection = selectedIds.length === 1;
    const hasMultipleSelection = selectedIds.length > 1;
    const hasData = clientes && clientes.length > 0;

    return {
      nuevo: hasNoSelection && hasData,
      editar: hasSingleSelection && hasData,
      eliminar: (hasSingleSelection || hasMultipleSelection) && hasData
    };
  }, [selectedIds, clientes]);

  const handleRefresh = useCallback(() => {
    refetch();
  }, [refetch]);

  const handleExportExcel = useCallback(async () => {
    setExporting(true);
    try {
      const result = await getClientesConTarjetas();
      if (result.success && result.error === 0 && result.data) {
        const clientesData = result.data.data || result.data;
        
        const datosParaExcel = clientesData.map(cliente => ({
          'ID Cliente': cliente.IdCliente,
          'Nombres': cliente.Nombres,
          'Apellidos': cliente.Apellidos,
          'Email': cliente.Email,
          'Teléfono': cliente.Phone,
          'Fecha Nacimiento': cliente.Fecha_Nacimiento ? cliente.Fecha_Nacimiento.split('T')[0] : '',
          'Ciudad': cliente.Ciudad,
          'Estado': cliente.Estado,
          'Número Tarjeta': cliente.NumeroTarjeta,
          'Tipo Tarjeta': cliente.TipoTarjeta ,
          'Mes Vencimiento': cliente.MesVencimiento,
          'Año Vencimiento': cliente.AniVencimiento,
          'Vencimiento': cliente.Vencimiento,
          'Estatus': cliente.Estatus === 'A' ? 'Activo' : 'Inactivo'
        }));

        const ws = XLSX.utils.json_to_sheet(datosParaExcel);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Clientes con Tarjetas');
        
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        
        const fecha = new Date().toISOString().split('T')[0];
        saveAs(blob, `Clientes_Tarjetas_${fecha}.xlsx`);
        
        showSuccess('Excel exportado correctamente');
      } else {
        showError(result.mensaje || 'Error al exportar clientes');
      }
    } catch (error) {
      showError('Error al exportar clientes');
    } finally {
      setExporting(false);
    }
  }, [showSuccess, showError]);

  return (
    <div className="bodyClientes">

      {/* TÍTULO */}
      <div className='tituloClientes'><p>Clientes</p></div>

      {/* CONTENIDO SUPERIOR */}
      <div className='contenidoSuperiorClientes'>
        <div className='botonesClientes'>
{/*
          <button
            className='botonesEdicionClientes'
            onClick={() => navigate("/dashboard/clientes/editarcliente")}
            disabled={!buttonStates.nuevo}
            title={buttonStates.nuevo ? "Agregar nuevo cliente" : "Deshabilitado cuando hay selección"}
          >
            <div className="svgBotonesClientes"><Editar className="logo-svgBotones" /></div>
            Agregar Cliente
          </button>

          <button 
            className='botonesEdicionClientes'
            disabled={!buttonStates.editar}
            onClick={handleEditSelected}
            title={buttonStates.editar ? "Editar cliente seleccionado" : "Selecciona un cliente para editar"}
          >
            <div className="svgBotonesClientes"><Editar className="logo-svgBotones" /></div>
            Editar Cliente
          </button>
*/}

          <button 
            className='botonesEdicionClientes'
            disabled={!buttonStates.eliminar}
            onClick={handleDeleteSelected}
            title={buttonStates.eliminar ? `Eliminar ${selectedIds.length} cliente(s)` : "Selecciona clientes para eliminar"}
          >
            <div className="svgBotonesClientes"><Eliminar className="logo-svgBotones" /></div>
            Eliminar Cliente{selectedIds.length > 1 ? 's' : ''}
          </button>

          <button 
            className='botonesEdicionClientes'
            onClick={handleRefresh}
            disabled={loading}
            title="Recargar clientes"
          >
            <div className="svgBotonesClientes">
              <Recargar className={`logo-svgBotones ${loading ? 'rotating' : ''}`} />
            </div>
            Recargar
          </button>

          <button 
            className='botonesEdicionClientes'
            onClick={handleExportExcel}
            disabled={exporting}
            title="Exportar clientes con tarjetas a Excel"
          >
            <div className="svgBotonesClientes">
              <ExcelIcon className="logo-svgBotones" />
            </div>
            {exporting ? 'Exportando...' : 'Exportar Excel'}
          </button>
        </div>
      </div>

      {/* AQUÍ SE MOSTRARÁ LA TABLA */}
      <div className="tablaContainerClientes">
        <TablaClientes 
          clientes={clientes}
          loading={loading}
          error={error}
          onRetry={refetch}
          emptyStateNoReload={true}
          pageSize={20}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          onSelectionChange={(selectedIdsList) => {
            setSelectedIds(selectedIdsList || []);
            if (currentPage !== 1) {
              setCurrentPage(1);
            }
          }}
        />
      </div>

      <BulkDeleteModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onComplete={handleDeleteComplete}
        title="Eliminar Clientes"
        items={deletingItems}
        onDelete={handleConfirmDelete}
        getItemId={(item) => item.IdCliente}
        getItemLabel={(item) => `${item.Nombres} ${item.Apellidos}`}
        entityName="cliente"
      />

    </div>
  );
}

export default Clientes;
